import { useContext } from "react";

import { AuthContext, type AuthState } from "../context/authState.js";

export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside <AuthProvider>.");
  }

  return context;
}
